query ListShopifyProducts($shop: String!, $query: String) {
  products: StreamToolsListShopifyProducts(shop: $shop, query: $query) {
    productId
    title
    imageUrl
    images {
      mediaId
      url
      altText
      contentType
    }
    priceCents
    linkUrl
    realOptionCount
  }
}
